import React, { memo, FC } from "react";
import BaseTooltipWrapper from "@/components/BaseWrappers/BaseTooltipWrapper";
import { additionalInfoText } from "@/utils/constants/tooltipsInfo";
import { InfoCircledIcon } from "@radix-ui/react-icons";
import { Badge, Flex, Text } from "@radix-ui/themes";

const SingleChallengeAdditionalInfoWithTooltip: FC<{
  title: string;
  value: string;
  tooltip?: string;
  gameType?: string;
}> = ({ title, value, tooltip, gameType }): JSX.Element => {
  const isAccumulative = value === "Cumulative";
  const isRecord = value === "Record";

  // Games
  const isRacing = gameType?.includes("fm8");

  const isMap = title === "Maps";

  return (
    <BaseTooltipWrapper
      overlayTrigger={
        <Flex gap="1" align="center" style={{ cursor: "pointer" }}>
          <Badge>
            {isAccumulative ? (
              <Text>Accumulative</Text>
            ) : isRecord ? (
              <Text>Record</Text>
            ) : (
              <Text>
                {isMap && isRacing ? "Track" : title}: {value}
              </Text>
            )}
            <InfoCircledIcon />
          </Badge>
        </Flex>
      }
      tooltipContent={additionalInfoText[tooltip || title]}
    />
  );
};

export default memo(SingleChallengeAdditionalInfoWithTooltip);
